import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=0c735944&scoped=true"
import script from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=0c735944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c735944",
  null
  
)

export default component.exports